import { useEffect, useRef, useState } from "react";
import { Camera, Trash2 } from "lucide-react";
import { toast } from "sonner";
import { api, errMsg } from "@/lib/api";

const cache = new Map();

const fetchPhoto = (id, v) => {
  const key = `${id}:${v}`;
  if (!cache.has(key)) cache.set(key, api.get(`/rrhh/employees/${id}/photo`, { params: { v }, responseType: "blob" }).then((r) => URL.createObjectURL(r.data)).catch(() => null));
  return cache.get(key);
};

const initials = (name = "") => name.replace(",", "").split(" ").filter(Boolean).slice(0, 2).map((w) => w[0]).join("").toUpperCase();

export const EmployeeAvatar = ({ id, v, name, size = 32, testid }) => {
  const [src, setSrc] = useState(null);
  useEffect(() => { let alive = true; setSrc(null); if (v) fetchPhoto(id, v).then((u) => alive && setSrc(u)); return () => { alive = false; }; }, [id, v]);
  const style = { width: size, height: size, fontSize: Math.max(10, size * 0.36) };
  return src
    ? <img src={src} alt={name} style={style} data-testid={testid || `emp-avatar-${id}`} className="rounded-full object-cover shrink-0 border border-[#e4e8e1]" />
    : <span style={style} data-testid={testid || `emp-avatar-${id}`} className="rounded-full shrink-0 grid place-items-center bg-[#e9f7e1] text-[#1c6e00] font-bold">{initials(name)}</span>;
};

export const PhotoEditor = ({ emp, canEdit, onChanged }) => {
  const input = useRef(null);
  const [busy, setBusy] = useState(false);
  const upload = async (e) => {
    const file = e.target.files?.[0];
    if (!file) return;
    const fd = new FormData();
    fd.append("file", file);
    setBusy(true);
    try { await api.post(`/rrhh/employees/${emp.id}/photo`, fd); toast.success("Foto actualizada"); onChanged(); }
    catch (err) { toast.error(errMsg(err)); }
    finally { setBusy(false); e.target.value = ""; }
  };
  const remove = async () => { try { await api.post(`/rrhh/employees/${emp.id}/photo/remove`); toast.success("Foto quitada"); onChanged(); } catch (err) { toast.error(errMsg(err)); } };
  return (
    <div className="relative group shrink-0 w-fit" data-testid="photo-editor">
      <EmployeeAvatar id={emp.id} v={emp.photo_v} name={emp.full_name} size={88} testid="employee-photo" />
      {canEdit && <>
        <input ref={input} type="file" accept=".jpg,.jpeg,.png,.webp" className="hidden" onChange={upload} data-testid="photo-input" />
        <button data-testid="photo-upload-btn" disabled={busy} title="Subir o cambiar foto" onClick={() => input.current?.click()}
          className="absolute -bottom-1 -right-1 h-8 w-8 rounded-full bg-[#258F00] text-white grid place-items-center shadow transition-transform hover:scale-110"><Camera size={15} /></button>
        {emp.photo_v && <button data-testid="photo-remove-btn" title="Quitar foto" onClick={remove}
          className="absolute -top-1 -right-1 h-6 w-6 rounded-full bg-white border text-[#b42318] grid place-items-center opacity-0 group-hover:opacity-100 transition-opacity"><Trash2 size={12} /></button>}
      </>}
    </div>
  );
};
